import client from '@/http'

const loadAll = (context) => {
  client.get(
    'columns'
  ).then(
    (res) => {
      context.commit('SET_COLUMNS', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const load = (context, params) => {
  client.get(
    `columns/${params.model}/${params.id}/bundle/${params.bundleId}`
  ).then(
    (res) => {
      context.commit('SET_COLUMNS', res.data)
    }
  ).catch(
    (err) => {
      console.error(err)
    }
  )
}

const save = (context, params) => {
  if (params.id) {
    client.put(
      `columns/${params.id}`, params
    ).then(
      () => {
        context.commit('UPDATE', params)
      }
    ).catch(
      (err) => {
        console.error(err)
      }
    )
  } else {
    client.post(
      'columns', params
    ).then(
      (res) => {
        context.commit('PUSH', res.data)
      }
    ).catch(
      (err) => {
        console.error(err)
      }
    )
  }
}

export default {
  save,
  load,
  loadAll
}
